/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitReserveSectionsListPathOrgUnitId, OrgUnitReserveSectionsListStatus200 } from "../types/OrgUnitReserveSectionsList.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgUnitReserveSectionsList } from "../requests/orgUnitReserveSectionsList.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgUnitReserveSectionsListQueryKey = (org_unit_id?: MaybeRefOrGetter<OrgUnitReserveSectionsListPathOrgUnitId>) =>
	[{ url: "/api/org_unit/:org_unit_id/reserve/sections/", params: { org_unit_id: org_unit_id } }] as const;

export type OrgUnitReserveSectionsListQueryKey = ReturnType<typeof orgUnitReserveSectionsListQueryKey>;

export function orgUnitReserveSectionsListQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveSectionsListPathOrgUnitId>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgUnitReserveSectionsListQueryKey(org_unit_id);
	return queryOptions<OrgUnitReserveSectionsListStatus200, ResponseErrorConfig<Error>, OrgUnitReserveSectionsListStatus200>({
		enabled: () => !!toValue(org_unit_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgUnitReserveSectionsList(toValue(org_unit_id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @summary залы точки со столами и схемой для бронирования
 * {@link /api/org_unit/:org_unit_id/reserve/sections/}
 */
export function useOrgUnitReserveSectionsList<
	TData = OrgUnitReserveSectionsListStatus200,
	TQueryData = OrgUnitReserveSectionsListStatus200,
	TQueryKey extends QueryKey = OrgUnitReserveSectionsListQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveSectionsListPathOrgUnitId>,
	options: {
		query?: Partial<UseQueryOptions<OrgUnitReserveSectionsListStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgUnitReserveSectionsListQueryKey(org_unit_id);

	const query = useQuery(
		{
			...orgUnitReserveSectionsListQueryOptions(org_unit_id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgUnitReserveSectionsListStatus200, ResponseErrorConfig<Error>, TData, OrgUnitReserveSectionsListStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
